{
  "field_groups": {
    "text_fields": "文本",
    "data_fields": "数据",
    "order_fields": "收款",
    "rating_fields": "评分",
    "selectable_fields": "选择",
    "contact_fields": "联系信息",
    "display_fields": "展示",
    "advanced_fields": "高级字段"
  },
  "fields": {
    "TextField": {
      "type_name": "单行文字",
      "default_label": "单行文字"
    },
    "TextArea": {
      "type_name": "多行文字",
      "default_label": "多行文字"
    },
    "RadioButton": {
      "type_name": "单项选择",
      "default_label": "单项选择"
    }
  }
}
